import React from 'react';
import { Divider } from '@mui/material';

const ToolbarDivider: React.FC = () => {
  return <Divider orientation='vertical' flexItem />;
};

export default ToolbarDivider;

